import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { featureNameTasklist, reducerTasklist, TasklistEffects } from '@app/+task-list/store';
import { EffectsModule } from '@ngrx/effects';

@NgModule({
    imports: [
        StoreModule.forFeature(featureNameTasklist, reducerTasklist),
        EffectsModule.forFeature([TasklistEffects])
    ]
})
export class TaskListStateModule { }
